if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.loadState === 'loaded' || this.loadState === 'loading') return;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.init();
            }
          }, {rootMargin:'400px'});
          this.observer.observe(this.closest('.product__block') || this.closest('.shopify-section') || this);
        } else this.init();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        if (this.loadState === 'loading') this.loadState = 'idle';
      }

      init() {
        if (!this.isConnected || this.loadState === 'loading' || this.loadState === 'loaded') return;
        this.loadState = 'loading';
        const controller = new AbortController();
        this.controller = controller;
        fetch(this.dataset.url, {signal:controller.signal})
          .then((response) => { if (!response.ok) throw new Error('Recommendation request failed'); return response.text(); })
          .then((responseText) => {
            if (!this.isConnected || controller.signal.aborted) return;
            this.loadState = 'loaded';
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations?.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (this.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            if (controller.signal.aborted) return;
            this.loadState = 'idle';
            console.error(e);
          });
      }
    }
  );
}
